
/**
 * Exports.
 */

export {
  categoryFiltered,
  clickedUpgradeButton,
  clickedUpgradeLink,
  deletedTrackEvent,
  disabledTrackEvent,
  enabledTrackEvent,
  enforcementNotificationClicked,
  enforcementNotificationShown,
  featureRequested,
  integrationsDetectClicked,
  integrationsDetectInstalled,
  integrationsDetectResult,
  siteExited,
  sourcesLinkClicked,
  sourceAuthorizeClicked,
  sourceBasicSettingsChanged,
  sourceDeleteClicked,
  sourceDetailPage,
  sourceFinishedPage,
  sourceMoved,
  sourceNamingPage,
  sourceOverviewPage,
  sourceOverviewAccordionToggled,
  sourceOverviewLinkClicked,
  sourceRunPage,
  sourcesCatalogPage,
  sourceSchemaRefreshClicked,
  sourceSchemaRefreshed,
  sourceSettingsBasicPage,
  sourceSettingsCollaboratorPage,
  sourceSettingsMovePage,
  sourceSettingsSqlPage,
  sourceSettingsCrossDomainAnalyticsPage,
  sourcesPage,
  sourceSQLSettingsChanged,
  sourceSyncLatestPage,
  trackFilteredIntegrations,
  updatedTrackEvent,
  viewedIntegration,
  viewedSchema,
  viewedSourceIntegrations,
  viewedSourceKeys,
  viewedSourceSchemaSettings,
  writeKeyChangeClicked,
  writeKeyChanged
}

function viewedSourceSchemaSettings (source, workspace) {
  window.analytics.page('Source Settings Schema', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasSentData
  })
}

function sourceSchemaRefreshClicked (source, workspace) {
  window.analytics.track('Source Schema Refresh Clicked', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasSentData
  })
}

function sourceSchemaRefreshed (source, workspace) {
  window.analytics.track('Source Schema Refreshed', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasSentData
  })
}

function viewedSourceKeys (source, workspace) {
  window.analytics.page('Source Settings Keys', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasSentData
  })
}

function writeKeyChangeClicked (source, workspace) {
  window.analytics.track('Write Key Change Clicked', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasS
  })
}

function writeKeyChanged (source, workspace) {
  window.analytics.track('Write Key Changed', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasS
  })
}

function clickedUpgradeButton () {
  window.analytics.track('Upgrade Modal Clicked')
}

function clickedUpgradeLink () {
  window.analytics.track('Upgrade Modal Clicked')
}

function categoryFiltered (value, location, countResults) {
  window.analytics.track('Category Filtered', {
    category: value,
    category_location: location,
    category_results_count: countResults
  })
}

function siteExited (linkTarget, linkText, linkLocation) {
  window.analytics.track('Site Exited', {
    link_target: linkTarget,
    link_text: linkText,
    link_location: linkLocation
  })
}

function viewedIntegration (workspace, project, integration) {
  window.analytics.track('Viewed Integration', {
    workspaceId: workspace.id,
    workspaceLogin: workspace.slug,
    projectId: project.id,
    projectSlug: project.slug,
    integrationSlug: integration.slug,
    integrationTier: integration.level,
    integrationEnabled: integration.enabled
  })
}

function trackFilteredIntegrations (category, platform, search) {
  window.analytics.track('Filtered Integrations', {
    category: category,
    platform: platform,
    search: search
  })
}

function viewedSourceIntegrations (slug) {
  window.analytics.page('Integrations', {
    slug: slug,
    viewport: viewport()
  })
}

function integrationsDetectClicked (workspace, project) {
  window.analytics.track('Integrations Detect Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: project.slug,
    source_id: project.id
  })
}

function integrationsDetectResult (workspace, project, detectedIntegrations) {
  window.analytics.track('Integrations Detect Result', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: project.slug,
    source_id: project.id,
    detected: Object.keys(detectedIntegrations).join(', '),
    detected_count: Object.keys(detectedIntegrations).length
  })
}

function integrationsDetectInstalled (workspace, project, savedIntegrations, detectedIntegrations) {
  window.analytics.track('Integrations Detect Installed', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: project.slug,
    source_id: project.id,
    detected: Object.keys(detectedIntegrations).join(', '),
    detected_count: Object.keys(detectedIntegrations).length,
    installed: Object.keys(savedIntegrations).join(', '),
    installed_count: Object.keys(savedIntegrations).length
  })
}

function updatedTrackEvent (workspace, project, event) {
  window.analytics.track('Event Updated', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: project.id,
    source_slug: project.slug,
    event_name: event.name
  })
}

function deletedTrackEvent (workspace, project, event) {
  window.analytics.track('Event Deleted', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: project.id,
    source_slug: project.slug,
    event_name: event.name
  })
}

function enabledTrackEvent (workspace, project, event) {
  window.analytics.track('Event Enabled', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: project.id,
    source_slug: project.slug,
    event_name: event.name
  })
}

function disabledTrackEvent (workspace, project, event) {
  window.analytics.track('Event Disabled', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: project.id,
    source_slug: project.slug,
    event_name: event.name
  })
}

function viewedSchema () {
  window.analytics.page('Schema', {
    viewport: viewport()
  })
}

function sourceRunPage ({ type, source, lastRun, workspace }) {
  window.analytics.page('Source Run', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    last_run_collection_nb: lastRun.collections.length,
    last_run_success: lastRun.success,
    last_run_synced_nb: lastRun.synced
  })
}

/**
 * Sources Link Clicked
 */

function sourcesLinkClicked (workspaceId, workspaceSlug, action, sourceMetadataSlug = undefined) {
  window.analytics.track('Sources Link Clicked', {
    workspace_id: workspaceId,
    workspace_slug: workspaceSlug,
    action,
    source_metadata_slug: sourceMetadataSlug
  })
}

/**
 * Clicking to Authorize Source.
 */

function sourceAuthorizeClicked ({ workspace, sourceMetadata, sourceSetting }) {
  window.analytics.track('Source Authorize Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: sourceSetting.slug,
    source_name: sourceSetting.name,
    source_id: sourceSetting.id,
    source_metadata_slug: sourceMetadata.slug,
    source_type: sourceMetadata.type
  })
}

/**
 * Changing Source Basic Settings
 */

function sourceBasicSettingsChanged (source, newName, workspace) {
  window.analytics.track('Source Basic Settings Changed', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_name: newName,
    source_id: source.id,
    source_enabled: !source.enabled,  // added a bang! bc source.enabled is the previous state
    source_old_name: source.name,
    source_slug: source.slug
  })
}

/**
 * Changing SQL Schema Name
 */

function sourceSQLSettingsChanged (source, newSlug, workspace) {
  window.analytics.track('Source SQL Settings Changed', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: newSlug,
    source_id: source.id,
    source_enabled: source.enabled,
    source_old_slug: source.slug
  })
}

/**
 * Moving Source To a New Workspace
 */

function sourceMoved (source, newWorkspaceSlug, workspace) {
  window.analytics.track('Source Moved', {
    workspace_id: workspace.id,
    workspace_slug: newWorkspaceSlug,
    source_slug: source.slug,
    source_id: source.id,
    source_enabled: source.enabled,
    workspace_old_slug: workspace.slug
  })
}

/**
 * Clicking to Delete a Source
 */

function sourceDeleteClicked (source, workspace) {
  window.analytics.track('Source Delete Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_slug: source.slug,
    source_id: source.id,
    source_enabled: source.enabled,
    source_count: workspace.projects.length
  })
}

/**
 *  Sources Page
 */

function sourcesPage (workspace) {
  window.analytics.page('Sources', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 *  Sources Catalog Page
 */

function sourcesCatalogPage (workspace) {
  window.analytics.page('Sources Catalog', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 *  Sources Detaail Page
 */

function sourceDetailPage (sourceMetadata, workspace) {
  window.analytics.page('Source Detail', {
    source_metadata_slug: sourceMetadata.slug,
    source_type: sourceMetadata.type,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 *  Sources Naming Page
 */

function sourceNamingPage (sourceMetadata, workspace) {
  window.analytics.page('Source Naming', {
    source_metadata_slug: sourceMetadata.slug,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_type: sourceMetadata.type
  })
}

/**
 * Source Finished Page
 */

function sourceFinishedPage (sourceMetadata, workspace) {
  window.analytics.page('Source Finished', {
    source_metadata_slug: sourceMetadata.slug,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 * Source Overview Page.
 */

function sourceOverviewPage () {
  window.analytics.page('Source Overview')
}

function sourceOverviewAccordionToggled (workspace, source, accordion) {
  window.analytics.track('Source Overview Accordion Toggled', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: source.id,
    source_slug: source.slug,
    accordion
  })
}

function sourceOverviewLinkClicked (workspace, source, link) {
  window.analytics.track('Source Overview Link Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: source.id,
    source_slug: source.slug,
    link
  })
}

/**
 * Source Latest Sync Page
 */

function sourceSyncLatestPage (source, workspace) {
  window.analytics.page('Source Sync Latest', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 * Source Basic Settings Page
 */

function sourceSettingsBasicPage (source, workspace) {
  window.analytics.page('Source Settings Basic', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_enabled: source.enabled,
    source_has_sent_data: source.hasSentData
  })
}

/**
 * Source Collaborator Settings Page
 */

function sourceSettingsCollaboratorPage (source, workspace) {
  window.analytics.page('Source Settings Collaborators', {
    source_slug: source.slug,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    source_collaborators: source.collaborators.length,
    source_has_sent_data: source.hasSentData,
    source_enabled: source.enabled
  })
}

/**
 * Source Basic Settings Page
 */

function sourceSettingsSqlPage (source, workspace) {
  window.analytics.page('Source Settings SQL', {
    source_slug: source.slug,
    source_name: source.name,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 * Source Cross Domain Analytics Settings Page
 */

function sourceSettingsCrossDomainAnalyticsPage (source, workspace) {
  window.analytics.page('Source Settings Cross Domain Analytics', {
    source_slug: source.slug,
    source_name: source.name,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

/**
 * Source Move Settings Page
 */

function sourceSettingsMovePage (source, workspace) {
  window.analytics.page('Source Settings Move', {
    source_slug: source.slug,
    source_name: source.name,
    source_id: source.id,
    workspace_slug: workspace.slug,
    workspace_id: workspace.id
  })
}

function enforcementNotificationShown (workspace, feature, targetPlan) {
  window.analytics.track('Enforcement Notification Shown', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    feature,
    target_plan: targetPlan
  })
}

function enforcementNotificationClicked (workspace, feature, targetPlan) {
  window.analytics.track('Enforcement Notification Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    feature,
    target_plan: targetPlan
  })
}

function featureRequested (workspace, source, feature) {
  window.analytics.track('Feature Requested', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: source.id,
    source_slug: source.slug,
    feature_name: feature
  })
}

function viewport () {
  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  return width + 'x' + height
}



// WEBPACK FOOTER //
// ./pages/workspace-sources/shared/analytics/index.js